import {EventEmitter, Injectable} from '@angular/core';
import {ResponseDto} from '../dto/ResponseDto';
import {Observable} from 'rxjs/internal/Observable';
import {MessageAttachment} from '../dto/MessageAttachment';
import {
    InputSourceType
} from 'botato-botengine-browser/botato/botato-botengine/source/InstantMessagingAdapter/WebSocket/dto/InputSourceType.js';

@Injectable()
export abstract class CommunicationService {

    public lastBotResult: ResponseDto | undefined;
    public lastHistoryBotResult: ResponseDto | undefined;
    // Both are set by BotatoChatComponent from its inputs before a connection is made
    public clientId!: string;
    public botId!: string;
    public alreadyConnected: boolean = false;

    public abstract alreadyConnectChanged$: Observable<boolean>;
    public abstract authenticationFailed: EventEmitter<void>;
    public abstract messageReceived: EventEmitter<ResponseDto>;
    public abstract messageSent: EventEmitter<void>;
    public abstract eventSent: EventEmitter<void>;
    public abstract historyReceived: EventEmitter<(ResponseDto | string)[]>;
    public abstract connectionStateChanged: EventEmitter<boolean>;
    public abstract startTyping: EventEmitter<ResponseDto>;
    public abstract messageSendingStarted: EventEmitter<void>;
    public abstract messageSendingFinished: EventEmitter<void>;
    public abstract thinkingIndicator: EventEmitter<void>;
    public abstract unreadStatusReceived: EventEmitter<boolean>;
    public abstract lastReadAtReceived: EventEmitter<string | undefined>;

    public abstract welcome(): Promise<void> ;

    public abstract sendMarkAsRead(): Promise<void> ;

    public abstract sendMessage(text: string, inputSource: InputSourceType, attachment?: MessageAttachment): Promise<void> ;

    // eslint-disable-next-line
    public abstract sendEvent(eventName: string, inputSource: InputSourceType, eventPayload: any): Promise<void> ;

    public abstract setAccessTokenProvider(provider: () => Promise<string>): void;

    public abstract connect(overtakeConnection: boolean): Promise<boolean>;

    public abstract setBotId(botId: string): void;

    public abstract disconnect(): Promise<void>;
}
